import axios from "../../axios";
export const CreateHospicashLead = async (
	title,
	insuredName,
	contactNumber,
	email,
	dateOfBirth,
	premiumUID
) => {
	const payload = {
		title,
		insuredName,
		contactNumber,
		email,
		dateOfBirth,
		premiumUID,
	};

	try {
		const response = await axios.post(
			"/api/Hospicash/HospicashLead/CreateLead",
			payload
		);

		return response;
	} catch (error) {
		if (error.response) {
			console.log("API Error:", error.response.data);
			throw new Error(error.response.data.message || "Failed");
		}

		throw new Error("Network Error");
	}
};

export const GetLeadDetails = async (uid) => {
	return await axios.post("/api/Hospicash/HospicashLead/GetLeadDetails", {
		hospicashLeadUID: uid,
	});
};

export const UpdateLeadDetails = (payload) => {
	return axios.post("/api/Hospicash/HospicashLead/UpdateLeadDetails", payload);
};
